import PropTypes from 'prop-types';
import { ICON_NAMES } from './constants/iconNames';
export const headerItemPropTypes = {
  breakpoint: PropTypes.shape({
    mobile: PropTypes.bool,
    desktop: PropTypes.bool
  }),
  href: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  badge: PropTypes.string,
  expandAndFocusSearchBar: PropTypes.func,
  iconName: PropTypes.oneOf(Object.keys(ICON_NAMES)),
  classname: PropTypes.string
};